<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import useThemeVars from '@lib/composables/useThemeVars'
import type { BulkDeleteErrorDetail } from '@openapi'

const { t } = useI18n()
const themeVars = useThemeVars()

export type CBulkDeleteErrorDetails = Omit<BulkDeleteErrorDetail, 'error'> & {
  name: string
  error?: string
}

defineProps<{
  errorsDetails: CBulkDeleteErrorDetails[]
  nameText?: string
  idText?: string
  msgText?: string
}>()
</script>

<template>
  <div class="mb-2">{{ t('canvasUI.components.templates.CBulkDeleteErrors.title') }}</div>
  <table class="w-full">
    <thead>
      <tr>
        <th class="text-left px-2 py-1 font-bold bg-primary5">
          {{ nameText ?? t('canvasUI.components.templates.CBulkDeleteErrors.name') }}
        </th>
        <th class="text-left px-2 py-1 font-bold bg-primary5">
          {{ idText ?? t('canvasUI.components.templates.CBulkDeleteErrors.id') }}
        </th>
        <th class="text-left px-2 py-1 font-bold bg-primary5">
          {{ msgText ?? t('canvasUI.components.templates.CBulkDeleteErrors.errorMessage') }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="({ id, name, error_message }, i) in errorsDetails" :key="i" class="mb-2">
        <td class="px-2 py-1">{{ name }}</td>
        <td class="px-2 py-1">{{ id }}</td>
        <td class="px-2 py-1">{{ error_message }}</td>
      </tr>
    </tbody>
  </table>
</template>

<style lang="scss" scoped>
td {
  border-bottom: 1px solid v-bind('themeVars.primary5');
}
</style>
